import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from './../images/info.png'
import _imports_1 from '../images/user.png'


const _hoisted_1 = { class: "cm-align-center cm-ui-mb15" }
const _hoisted_2 = {
  key: 0,
  class: "cm-ui-ml15",
  style: {"color":"gray"}
}
const _hoisted_3 = { style: {"white-space":"pre-line"} }
const _hoisted_4 = {
  key: 0,
  style: {"color":"red"},
  class: "cm-align-center"
}
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "cm-ui-ml5",
  width: "16",
  alt: ""
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "cm-align-center cm-ui-mb15" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "20",
  height: "20",
  class: "cm-ui-mr10",
  alt: ""
}, null, -1)
const _hoisted_9 = {
  class: "",
  style: {"line-height":"normal"}
}

import CmTable from '@/components/cmTable/index.vue'
import { nextTick, reactive, ref, watch, computed } from 'vue'
import { TableOpt } from '@/components/cmTable/types'
import { DateType, FormActionType, FormSize, FormSizeType, FormType } from '@/components/cmForm/types'
import { AccountStatus, BaseInfoService } from '@/views/dashboard/group/client/terminal-info/base-info/base-info.service'
import { BaseInfoRes, TerminalInfoService } from '@/views/dashboard/group/client/terminal-info/terminal-info.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { formatTimeStamp } from '@/utils/time'
import { TerminalLoginStatus } from '@/views/dashboard/_enum/terminal-login-status'
import { ElMessage, ElMessageBox } from 'element-plus'
import { team } from '@/common/basis/root-injector'
import { useParseTime } from '@/hooks'
import dayjs from 'dayjs'
import { LastCommandTaskData, ResponseHandlingService } from '../service'
import { login_status, parseWeakPasswordTypes, WEAK_PASSWORD_TYPE_I18N_KEY } from '../types'
import { useI18n } from 'vue-i18n'
import { listCol } from '@/utils/list-columns-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountInfo',
  props: {
  deviceId: {
    type: String,
  },
  info: {
    type: Object,
  },

  refreshApi: {
    type: Function,
  },
  api: {
    type: Function,
  }
},
  emits: ['refresh'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t, locale } = useI18n()

function accountStatusText(val: number): string {
  void locale.value
  const keys: Record<number, string> = {
    [AccountStatus.enable]: 'responseHandle.accountStatusEnabled',
    [AccountStatus.disable]: 'responseHandle.accountStatusDisabled',
    [AccountStatus.disabling]: 'responseHandle.accountStatusDisabling',
    [AccountStatus.enabling]: 'responseHandle.accountStatusEnabling',
  }
  const k = keys[val]
  return k ? t(k) : '--'
}
const props = __props
const emit = __emit
const injector = useReflectiveInjector([TerminalInfoService, BaseInfoService, ResponseHandlingService])
const service = injector.get(TerminalInfoService)
const baseService = injector.get(BaseInfoService)
const isLoading = ref(false)
const baseInfo = ref({} as BaseInfoRes)
let statusInterval: ReturnType<typeof setInterval> | null = null
const historyTableRef = ref()
const formType = ref(FormActionType.Other)
const formSize: FormSizeType = FormSize.Small
const defaultDate = [dayjs().subtract(7, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
const [start_time, end_time] = useParseTime(defaultDate)
const queryForm = reactive({ device_id: props.deviceId, name: '', team_id: null, start_time, end_time, domain: '' })
const visible = ref(false)
const loading = ref(false)
const tableActOpt = computed(() => ({
  isLink: true,
  columnOpt: { label: t('responseHandle.operation'), width: 150, align: 'left', fixed: 'right' },
  actionButtons: ({ status, ...item }) => [
    {
      name: status === 1 ? t('responseHandle.disable') : t('responseHandle.enable'),
      disabled: () => props.info.login_status !== TerminalLoginStatus.online,
      opt: { size: formSize, type: status === 1 ? 'danger' : 'primary', },
      events: {
        async click(e) {
          e.preventDefault()
          const enableAccountNum = (baseInfo.value.accounts ?? []).filter(v => v.status === AccountStatus.enable).length
          if (enableAccountNum <= 1 && status === 1) {
            ElMessage.error(t('responseHandle.cannotDisableKeepOne'))
            return
          }
          await ElMessageBox.confirm(status === 1 ? t('responseHandle.confirmDisableAccount') : t('responseHandle.confirmEnableAccount'), t('responseHandle.tip'), { confirmButtonText: t('responseHandle.confirm'), cancelButtonText: t('responseHandle.cancel') })
          await baseService.disableAccount({
            device_id: props.deviceId,
            name: item.name,
            status: status === AccountStatus.disable ? AccountStatus.enable : AccountStatus.disable
          })
          await updateData()
          emit('refresh')
        }
      }
    },
    {
      name: t('responseHandle.loginHistory'), opt: { size: formSize, type: 'primary' },
      events: {
        async click(e) {
          e.preventDefault()
          visible.value = true
          queryForm.name = item.name
          queryForm.team_id = team.getCurrentTeam().team_id
          queryForm.domain = item.domain
          await nextTick()
          historyTableRef?.value?.getList?.()
        }
      }
    },
  ],
}))
const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return ({
  bodyStyle: 'background: transparent;padding:0 16px;',
  hiddenPageTool: true,
  containerOpt: { style: 'padding: 0;background: var(--cm-color-card-bg)' },
  'max-height': '400px',
  path: 'list',
  showActionBar: false,
  showForm: false,
  showRightToolbar: false,
  rowKey: 'device_id',
  selection: false,
  columns: [
    { label: t('responseHandle.accountName'), prop: 'name', },
    { label: t('responseHandle.accountType'), prop: 'is_admin', formatter: (_, val) => val === 1 ? t('responseHandle.admin') : t('responseHandle.nonAdmin') },
    { label: t('responseHandle.accountRisk'), prop: 'weak_password_type' },
    { label: listCol(t, 'status'), prop: 'status', formatter: (_, val) => accountStatusText(val as number) },
    { label: t('responseHandle.lastLoginTime'), prop: 'last_login_time', formatter: (_, val) => val ==='0' ? '--': formatTimeStamp(val, 'YYYY-MM-DD HH:mm') },
  ],
})
})
const historyTableOpt = computed<TableOpt>(() => ({
  loadMoreMode: false,
  usePagination:false,
  disableScrollLoad:true,
  bodyStyle: 'background: transparent;padding:0;',
  containerOpt: { style: 'padding: 0 0;background: var(--cm-color-card-bg)' },
  'max-height': '400px',
  path: 'data',
  showActionBar: false,
  showForm: false,
  showRightToolbar: false,
  rowKey: 'id',
  selection: false,
  columns: [
    { label: listCol(t, 'loginTime'), prop: 'login_time', formatter: (_, val) => val ==='0' ? '--': formatTimeStamp(val, 'YYYY-MM-DD HH:mm') },
    { label: t('responseHandle.logoutTime'), prop: 'logout_time', formatter: (_, val) => val ==='0' ? '--': formatTimeStamp(val, 'YYYY-MM-DD HH:mm') },
  ],
}))

const refreshPort = async () => {
  loading.value = true
  const result = await props.refreshApi({ device_list: [props.deviceId], group_id: props.info.group_id, execute_type: 0 }).catch(err => err)
  await getLastInfo()
  await updateData()
  loading.value = false
  if (result?.responseBody?.ret === 4931001 || [0,1].includes(lastResult.value.status)) {
    return ElMessage.success(t('responseHandle.taskSendingWait'))
  }
  ElMessage.success(t('responseHandle.commandSentListUpdate'))
  loading.value = false
}
const updateData = () => {
  isLoading.value = true
  service.getBaseInfo({
    device_id: props.deviceId
  }).then(res => {
    baseInfo.value = res
    startLoopStatus()
  }).finally(() => {
    isLoading.value = false
  })
}

const startLoopStatus = () => {
  clearInterval(statusInterval)
  statusInterval = setInterval(() => {
    const hasProcessing = (baseInfo.value.accounts ?? []).find(v => v.status === AccountStatus.enabling || v.status === AccountStatus.disabling)
    if (hasProcessing) {
      service.getBaseInfo({ device_id: props.deviceId }).then(res => {
        baseInfo.value = res
      })
    } else {
      clearInterval(statusInterval)
    }
  }, 500)
}
const lastResult = ref<Partial<LastCommandTaskData>>({})
const respService = injector.get(ResponseHandlingService)
const getLastInfo = async () => {
  const result = await respService.getCommandserverGetLastCommandTask({ device_list: [props.deviceId], command_id: 33 })
  if (!result?.data.length) return
  lastResult.value = result?.data?.[0] || {}
}
watch(() => props.deviceId, (nv, lv) => {
  if (!nv || lv === nv) return;
  queryForm.device_id = nv
  getLastInfo()
}, { immediate: true })

// 获取弱密码类型的提示内容
const weakPasswordTooltipContent = (value: number | string | null | undefined): string => {
  void locale.value
  if (!value || value === 0) {
    return t('responseHandle.normalPasswordAccount')
  }

  const types = parseWeakPasswordTypes(value)
  if (types.length === 0) {
    return t('responseHandle.weakPasswordAccountLabel')
  }

  const typeTexts = types.map((type, index) => {
    const subKey = WEAK_PASSWORD_TYPE_I18N_KEY[type]
    const line = subKey ? `${index + 1}. ${t('responseHandle.' + subKey)}` : ''
    return line
  }).filter(Boolean)
  return `${t('responseHandle.weakPasswordInfoIntro')}\n${typeTexts.join('\n')}`
}

__expose({
  updateData
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createBlock(CmTable, {
      tableOpt: tableOpt.value,
      data: baseInfo.value.accounts,
      "onUpdate:data": _cache[0] || (_cache[0] = ($event: any) => ((baseInfo.value.accounts) = $event)),
      formType: formType.value,
      "onUpdate:formType": _cache[1] || (_cache[1] = ($event: any) => ((formType).value = $event)),
      tableActOpt: tableActOpt.value
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"align-self":"flex-start"},
            plain: "",
            size: "small",
            loading: loading.value,
            disabled: __props.info?.login_status !== _unref(login_status).online,
            onClick: refreshPort
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.refresh')), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled"]),
          (lastResult.value.create_time)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('responseHandle.lastGetDataTime')) + _toDisplayString(_unref(dayjs)((lastResult.value.create_time as number) * 1000).format('YYYY-MM-DD HH:mm')), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      weak_password_type: _withCtx((slotProps) => [
        _createVNode(_component_el_tooltip, {
          class: "box-item",
          effect: "light",
          disabled: !(slotProps as any).value,
          placement: "top"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(weakPasswordTooltipContent((slotProps as any).value as number | string | null | undefined)), 1)
          ]),
          default: _withCtx(() => [
            ((slotProps as any).value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.$t('responseHandle.weakPasswordAccountLabel')) + " ", 1),
                  ((slotProps as any).value)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('responseHandle.normalPasswordAccount')), 1))
          ]),
          _: 2
        }, 1032, ["disabled"])
      ]),
      _: 1
    }, 8, ["tableOpt", "data", "formType", "tableActOpt"])), [
      [_directive_loading, isLoading.value]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
      width: 580,
      title: _ctx.$t('responseHandle.loginHistory')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('responseHandle.userLoginHistoryDays', { name: queryForm.name })), 1)
        ]),
        _createVNode(CmTable, {
          tableOpt: historyTableOpt.value,
          modelValue: queryForm,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryForm) = $event)),
          "first-loading": false,
          api: __props.api,
          formType: formType.value,
          "onUpdate:formType": _cache[3] || (_cache[3] = ($event: any) => ((formType).value = $event)),
          ref_key: "historyTableRef",
          ref: historyTableRef
        }, null, 8, ["tableOpt", "modelValue", "api", "formType"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})